// Промяната на цената, прочетена със знак: поевтиняването е отнета от
// заведението сума, поскъпването — добавена. Същият език като корекциите в
// „Отстъпки и надбавки", защото въпросът е същият — колко е раздадено.
//
// Клетката е ръчна, а не декларативна `money` с `negative`, защото знакът се
// слага ПРЕД стойността и се чете и в двете посоки; редът „Общо" минава през
// `meta.totalCell`, където знакът идва от самата сума.
//
// Отделен файл, а не локална функция в `priceChangesColumns`: файл, който
// изнася и компонент, и hook, чупи Fast Refresh
// (react-refresh/only-export-components).

import { fmtEuro } from "../../../../utils/currency";

/** Минус знак U+2212 — по-широк от дефиса и подравнен с цифрите. */
const MINUS = "−";

const MONO_NUMBER = "font-pos-mono tabular-nums";

type Props = {
  /** Отрицателна стойност = поевтиняване, положителна = поскъпване. */
  value: number;
  /** Вторият, помътнен ред: процентът със същата посока като сумата. */
  percent?: number;
};

export const PriceChangeAmount = ({ value, percent }: Props) => {
  // Под половин цент няма какво да се чете като промяна — нулата се приглушава,
  // за да не спори с реалните суми в колоната.
  if (Math.abs(value) < 0.005) {
    return (
      <span className={`${MONO_NUMBER} text-[12.5px] font-semibold text-faint`}>
        {fmtEuro(0)}
      </span>
    );
  }

  const isDown = value < 0;
  const sign = isDown ? MINUS : "+";
  const tone = isDown ? "text-danger-ink" : "text-info-deep";

  return (
    <span className={`flex flex-col items-end leading-[1.25] ${tone}`}>
      <span className={`${MONO_NUMBER} text-[12.5px] font-bold`}>
        {`${sign}${fmtEuro(Math.abs(value))}`}
      </span>
      {percent !== undefined ? (
        <span className={`${MONO_NUMBER} text-[11px] font-semibold opacity-80`}>
          {`${sign}${Math.abs(percent).toFixed(2)} %`}
        </span>
      ) : null}
    </span>
  );
};
